import get from 'lodash/get';

/**
 * Resolve a react-table-v6 style accessor against a row object.
 */
export function getLegacyColumnValue(row, accessor) {
  if (accessor == null || accessor === '') return undefined;
  if (typeof accessor === 'function') return accessor(row);
  return get(row, accessor);
}

/**
 * Render a react-table-v6 style column Cell (or accessor fallback).
 */
export function renderLegacyColumnCell(column, row, index) {
  const value = getLegacyColumnValue(row, column.accessor);
  if (typeof column.Cell === 'function') {
    return column.Cell({
      original: row,
      value,
      index,
      row: { original: row, value, index }
    });
  }
  return value ?? null;
}

export function getLegacyColumnWidthStyle(column) {
  const width = column.width ?? column.maxWidth ?? column.minWidth;
  if (width == null) return undefined;
  return {
    width,
    maxWidth: column.maxWidth ?? width,
    minWidth: column.minWidth ?? undefined
  };
}
